/**
 * artidomo Warenkorb-Hinweis:
 * 1. Voraussichtlicher DE-Versand (exakt berechenbar, da nur Deutschland):
 *    7,90 € Basis je Lager-Gruppe minus Staffel-Rabatt je Gruppe.
 * 2. Mindestbestellwert je Papiersorte + 1000-€-Fortschritt für Drucke.
 *
 * WICHTIG: GRUPPEN + Staffeln müssen mit der Rabatt-Funktion „versand-staffel"
 * (App artidomo-checkout-rules, Metafeld $app:config/versand_staffel) und dem
 * Skript scripts/shopify-versandprofile-zuordnung.js synchron bleiben!
 */
(function () {
  'use strict';
  var eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var laeuft = false;

  var BASIS = 790; /* Cents je Lager-Gruppe */
  var STD = [{ ab: 50000, rabatt: 790 }, { ab: 20000, rabatt: 300 }]; /* Cents */
  var GRUPPEN = [
    { name: 'druck', vendors: ['artidomo-printing'], stufen: [{ ab: 100000, rabatt: 790 }] },
    { name: 'lager1', vendors: ['ilford', 'tecco'], stufen: STD },
    { name: 'lager2', vendors: ['hahnemühle', 'awagami', 'rauch', 'mediajet'], stufen: STD },
    { name: 'lager3', vendors: ['canson', 'artidomo'], stufen: STD },
    { name: 'lager4', vendors: ['innova art'], stufen: STD },
    { name: 'teeinblue', vendors: ['teeinblue'], stufen: STD },
  ];

  function gruppeFuerVendor(vendor) {
    var v = String(vendor || '').toLowerCase();
    for (var i = 0; i < GRUPPEN.length; i++) {
      if (GRUPPEN[i].vendors.indexOf(v) !== -1) return GRUPPEN[i];
    }
    return { name: '__rest__', stufen: STD };
  }

  function rabattFuer(stufen, summe) {
    var rabatt = 0;
    for (var i = 0; i < stufen.length; i++) {
      if (summe >= stufen[i].ab && stufen[i].rabatt > rabatt) rabatt = stufen[i].rabatt;
    }
    return rabatt;
  }

  var OPTIONS_SKUS = ['PRODUCT-OPTIONS']; /* UploadLift-Wertträger, via _cl_options_id der Papierposition zugeordnet */

  function render(cart) {
    document.querySelectorAll('.artidomo-druck-hinweis').forEach(function (box) {
      var vendorDruck = box.getAttribute('data-vendor');
      var min = Number(box.getAttribute('data-mindestwert')) * 100;
      var frei = Number(box.getAttribute('data-versandfrei')) * 100;

      var sorten = {};
      var druckSumme = 0;
      var gruppenSummen = {};
      var gruppeHatVersand = {};
      var versandpflichtig = false;
      var optionsIdZuProdukt = {};
      var optionsZeilen = [];

      (cart.items || []).forEach(function (item) {
        var g = gruppeFuerVendor(item.vendor);
        gruppenSummen[g.name] = (gruppenSummen[g.name] || 0) + item.final_line_price;
        if (item.requires_shipping !== false) {
          gruppeHatVersand[g.name] = true;
          versandpflichtig = true;
        }
        if (item.vendor !== vendorDruck) return;
        var optionsId = item.properties && item.properties['_cl_options_id'];
        if (OPTIONS_SKUS.indexOf(item.sku) !== -1) {
          optionsZeilen.push({ optionsId: optionsId, betrag: item.final_line_price });
          druckSumme += item.final_line_price;
          return;
        }
        var s = sorten[item.product_id] || { titel: item.product_title, summe: 0 };
        s.summe += item.final_line_price;
        sorten[item.product_id] = s;
        druckSumme += item.final_line_price;
        if (optionsId) optionsIdZuProdukt[optionsId] = item.product_id;
      });

      optionsZeilen.forEach(function (opt) {
        var pid = opt.optionsId && optionsIdZuProdukt[opt.optionsId];
        if (pid && sorten[pid]) sorten[pid].summe += opt.betrag;
      });

      if (!versandpflichtig) {
        box.hidden = true; box.innerHTML = '';
        document.body.classList.remove('ad-express-aus');
        return;
      }

      var versand = 0;
      Object.keys(gruppenSummen).forEach(function (name) {
        if (!gruppeHatVersand[name]) return;
        var stufen = STD;
        for (var i = 0; i < GRUPPEN.length; i++) if (GRUPPEN[i].name === name) stufen = GRUPPEN[i].stufen;
        versand += Math.max(0, BASIS - rabattFuer(stufen, gruppenSummen[name]));
      });

      var html = '<div class="ad-druck-titel">Versand nach Deutschland: ' +
        (versand === 0 ? '<span class="ad-versand-frei">kostenlos</span>' : eur.format(versand / 100)) + '</div>' +
        '<div class="ad-druck-abholung">Abholung in Bochum: kostenlos</div>';

      var keys = Object.keys(sorten);
      /* Express-Buttons (Shop Pay/PayPal/GPay) im Warenkorb ausblenden, solange
         eine Papiersorte unter dem Mindestwert liegt — der PayPal-Express-Weg
         kann die Checkout-Sperre umgehen. */
      var verletzt = keys.some(function (k) { return sorten[k].summe < min; });
      document.body.classList.toggle('ad-express-aus', verletzt);
      if (keys.length) {
        html += '<div class="ad-druck-trenner">Druckservice: Mindestbestellwert ' + eur.format(min / 100) + ' je Papiersorte</div>';
        keys.forEach(function (k) {
          var s = sorten[k];
          var titel = String(s.titel).replace(/</g, '&lt;');
          if (s.summe >= min) {
            html += '<div class="ad-druck-zeile ok">✓ ' + titel + ': ' + eur.format(s.summe / 100) + '</div>';
          } else {
            html += '<div class="ad-druck-zeile fehlt">' + titel + ': ' + eur.format(s.summe / 100) +
              ' — es fehlen noch ' + eur.format((min - s.summe) / 100) + '</div>';
          }
        });
        if (druckSumme >= frei) {
          html += '<div class="ad-druck-versand ok">✓ Kostenloser Versand deiner Drucke</div>';
        } else {
          html += '<div class="ad-druck-versand">Noch ' + eur.format((frei - druckSumme) / 100) +
            ' Druckwert bis zum kostenlosen Versand (ab ' + eur.format(frei / 100) + ')</div>';
        }
      }
      box.innerHTML = html;
      box.hidden = false;
    });
  }

  function refresh() {
    if (laeuft) return;
    laeuft = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { laeuft = false; render(cart); })
      .catch(function () { laeuft = false; });
  }

  /* Warenkorb-Änderungen erkennen: fetch- und XHR-Aufrufe auf /cart/* abfangen.
     Fehler hier dürfen den Shop niemals stören. */
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var url = String((args[0] && args[0].url) || args[0] || '');
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(refresh, 300); }, function () {});
        }
      } catch (e) {}
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      try {
        if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
          this.addEventListener('load', function () { setTimeout(refresh, 300); });
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
